import * as THREE from 'three';

import { updateCameraConfig } from '../../state/appConfig';
import { CameraDirector } from './CameraDirector';

const INITIAL_POSITION = new THREE.Vector3(
    -1.0851021763789943,
    0.43560047138699426,
    0.46662588628486934,
);

interface PreviewTourParams {
    cameraDirector: CameraDirector;
    clock: THREE.Clock;
    fov: number;
}

export class PreviewTour {
    private clock: THREE.Clock;
    private cameraDirector: CameraDirector;
    private fov: number;
    private _completed = false;
    private orbitCenter = new THREE.Vector3(0, 0, 0);
    private deferred: { promise: Promise<void>, resolve: () => void };

    constructor(params: PreviewTourParams) {
        this.clock = params.clock;
        this.cameraDirector = params.cameraDirector;
        this.fov = params.fov;
        let resolve = () => {};
        const promise = new Promise<void>(r => {
            resolve = r;
        });
        this.deferred = { promise, resolve };
    }

    get completed() {
        return this._completed;
    }

    setOrbitCenter(orbitCenter: THREE.Vector3): void {
        this.orbitCenter.copy(orbitCenter);
    }

    start(): void {
        this.cameraDirector.transitionToPose({
            position: INITIAL_POSITION,
            target: this.orbitCenter,
            fov: this.fov,
        }, 1, () => {
            updateCameraConfig({ orbitAutoMove: true });
        }, this.clock.getElapsedTime(), false);
    }

    stop(): Promise<void> {
        this.cameraDirector.transitionToPose({
            position: INITIAL_POSITION,
            target: this.orbitCenter,
            fov: this.fov,
        }, 1, () => {
            updateCameraConfig({ orbitAutoMove: false });
            this._completed = true;
            this.deferred.resolve();
        }, this.clock.getElapsedTime(), false);
        return this.deferred.promise;
    }
}
